<template>
  <div
    class="list-complete-item q-my-lg q-pb-md"
    style="display: block;"
    data-test-id="menu-item-category"
  >
    <div class="text-h5 q-mb-md">
      {{ label }}
    </div>
    <div class="row q-col-gutter-lg">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MenuItemCategory',
  props: {
    label: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.list-complete-item {
  transition: all 0.5s;
  display: inline-block;
}
.list-complete-enter {
  opacity: 0;
  transform: translateX(0) translateY(0);
}
.list-complete-leave-to {
  opacity: 0;
  transform: translateX(0) translateY(0);
}
.list-complete-leave-active {
  position: absolute;
}
</style>
